<template>
  <div id="app">
    <router-view v-if="initialized" />
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    initialized () {
      return this.$store.getters.initialized
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 100vh;
  min-width: 100vw;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/App.vue